import { render, staticRenderFns } from "./CabinetStatus.vue?vue&type=template&id=6e23ff98&scoped=true"
import script from "./CabinetStatus.vue?vue&type=script&lang=js"
export * from "./CabinetStatus.vue?vue&type=script&lang=js"
import style0 from "./CabinetStatus.vue?vue&type=style&index=0&id=6e23ff98&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e23ff98",
  null
  
)

export default component.exports